import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react'
import { StoresContext } from '../../../provider/StoreProvider'
import { ProductCard, PagingContent, ParamOption } from '../../../components'
import { onParams, PARAM_FILTER, PARAM_SORT, EmptyPage } from '../../../common'
import { useIonViewWillEnter } from '@ionic/react'

export const MainSaleList: React.FC = observer(() => {
  const { authStore, marketStore } = useContext(StoresContext)
  const pagingStore = marketStore.salePagingStore
  const [sortType, setSortType] = useState<PARAM_SORT>(PARAM_SORT.LATEST)
  const [filterType, setFilterType] = useState(PARAM_FILTER.ALL)
  const [categoryIds, setCategoryIds] = useState<number>(0)

  useIonViewWillEnter(() => {
    pagingStore.load(undefined, true)
    setCategoryIds(0)
  })

  useEffect(() => {
    onParams({
      store: pagingStore,
      sortType: sortType,
      filterType: filterType,
      filterName: 'filter',
      categoryIds: categoryIds,
    })
  }, [sortType, filterType, categoryIds])

  const filterList = [
    {
      type: PARAM_FILTER.ALL,
      title: '전체보기',
    },
    {
      type: PARAM_FILTER.FAVORITE,
      title: '관심작품',
    },
  ]

  const sortList = [
    {
      type: 'LATEST',
      title: '최근 거래순',
    },
    {
      type: 'REMAIN',
      title: '잔여 조각순',
    },
    {
      type: 'END_DATE',
      title: '오래된 거래순',
    },
  ]

  return (
    <>
      <ParamOption
        filterData={{
          filterList: filterList,
          filterType: filterType,
          setFilterType: setFilterType,
        }}
        sortData={{
          sortList: sortList,
          setSortType: setSortType,
        }}
        categoryData={{
          categoryIds: categoryIds,
          setCategoryIds: setCategoryIds,
        }}
      />
      <ContentsContainer>
        {authStore.userInfo === null && filterType !== PARAM_FILTER.ALL ? (
          <EmptyPage icon={'warning'} content={'로그인 후 이용 가능합니다.'} isSignIn={true} />
        ) : (
          <PagingContent pagingStore={pagingStore} loadParam={{ data: { filter: filterType } }}>
            <ProductsContainer>
              {pagingStore.list.map((d, i) => (
                <ProductCard
                  key={i}
                  page={'SALE'}
                  img={d.imageUri}
                  artist={d.artist}
                  title={d.name}
                  routerLink={`/market/${d.id}`}
                  count={d.saleRemainCount}
                  cost={d.saleCost}
                  saleStatus={d.saleStatus}
                  status={d.status}
                  chipDday={Math.max(
                    0,
                    Math.floor((new Date(d.saleUntilDate).getTime() - new Date().getTime()) / (3600000 * 24)),
                  )}
                  isFavorite={d.favorite}
                />
              ))}
            </ProductsContainer>
          </PagingContent>
        )}
      </ContentsContainer>
    </>
  )
})

const ContentsContainer = styled.div`
  padding: 0 20px;
`

const ProductsContainer = styled.article`
  display: grid;
  grid-template-columns: repeat(2, minmax(160px, 100%));
  gap: 40px 15px;
`
